// extracted by mini-css-extract-plugin
module.exports = {"control":"LinksGroup_control__YfIdK","link":"LinksGroup_link__BvN__","link2":"LinksGroup_link2__naRdk","chevron":"LinksGroup_chevron__LrQsE"};